<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="$t('environmental-management.route-management.title')">
        </base-page-header>

        <!-- ADMIN -->
        <template v-if="isAdmin">
            <v-row>
                <v-col cols="9" class="d-flex align-center pt-0">
                    <h3>{{$t('environmental-management.route-management.admin-template.title')}}</h3>
                </v-col>
                <v-col cols="3" class="pt-0">
                    <div class="budget-history">
                        <router-link :to="{ name: 'environmentalManagementRouteManagementHistory' }" class="router_link_class">
                            <div class="history-btn">
                                <h5 class="white--text">{{$t('environmental-management.route-management.admin-template.history-routes')}}</h5>
                                <img class="ml-2 white--text" width="30" onload="SVGInject(this)" src="/images/_SVGs/retroceder.svg"/>
                            </div>
                        </router-link>
                    </div>
                </v-col>
                <v-col cols="12">
                    <RouteSegments :routes="routes" @showModal="showModal"/>
                </v-col>
            </v-row>

            <v-row>

                <v-col cols="12">
                    <div class="mt-4 p-4 bg-white" style="border-radius: 7px;">
                        <v-row v-if="isAdmin">
                            <v-col cols="12" sm="10">
                                <h3>{{$t('environmental-management.route-management.admin-template.list-of-requests')}}</h3>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="float-md-right mr-md-4 btn-add" @click="createSubRota()" v-bind="attrs" v-on="on">
                                            <img src="/images/_SVGs/bo/adicionar.svg" onload="SVGInject(this)" class="circle" width="20" />
                                        </div>
                                    </template>
                                    <span>{{$t('environmental-management.route-management.admin-template.create-route')}}</span>
                                </v-tooltip>

                            </v-col>
                        </v-row>
                        <SearchOrderWithoutRoute @on-search="onSearch"/>
                        <OrderWithoutRoute :items="tableEgars" :searchCount="searchCount" :totalRecords="totalRecords" @alterTable="alterTable" @deleteEgarId="deleteEgarById"/>
                    </div>
                </v-col>
            </v-row>
        </template>

        <!-- Transportador -->
        <template v-else>
            <v-row>
                <v-col cols="12" sm="3" class="mx-auto">
                    <v-row>
                        <v-col cols="12" class="mb-4">
                            <h3>{{$t('environmental-management.route-management.transporter-template.today')}}</h3>
                        </v-col>
                    </v-row>
                    <RouteSegmentsConveyor :routes="routesTransporterNow"/>
                </v-col>

                <v-col cols="12" sm="3" class="mx-auto">
                    <v-row>
                        <v-col cols="12" class="mb-4">
                            <h3>{{$t('environmental-management.route-management.transporter-template.tomorrow')}}</h3>
                        </v-col>
                    </v-row>
                    <RouteSegmentsConveyor :routes="routesTransporterTomorrow"/>
                </v-col>

                <v-col cols="12" sm="3" class="mx-auto">
                    <v-row>
                        <v-col cols="12" class="mb-4">
                            <h3>{{$t('environmental-management.route-management.transporter-template.next')}}</h3>
                        </v-col>
                    </v-row>
                    <RouteSegmentsConveyor :routes="routesTransporterOthers"/>
                </v-col>
            </v-row>
        </template>

        <base-modal v-model="modalShow.show" :title="$t('environmental-management.route-management.modal-show.title')" modalAlign="align__flex--center" modal-width="400px">
            <template v-slot:modal-body>
                <v-form v-model="modalShow.form.isValid">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                :items="modalShow.form.transporters.length > 0? modalShow.form.transporters.map(el => ({text: el.nif + ' - ' + el.fullName,value: el})) : []"
                                v-model="modalShow.form.transporter"
                                :rules="formRules.defaultRules"
                                filled
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.modal-show.intervening-type-req')"
                            ></v-autocomplete>
                        </v-col>


                        <v-col cols="12">
                            <v-text-field
                                :label="$t('environmental-management.route-management.modal-show.plate-nbr')"
                                v-model="modalShow.form.transporter.plateNumber"
                                filled
                                :rules="formRules.defaultRules"
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-menu
                                ref="menuDate"
                                v-model="menuDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="modalShow.form.data"
                                        :rules="formRules.defaultRules"
                                        :label="$t('environmental-management.route-management.modal-show.date-req')"
                                        persistent-hint
                                        v-bind="attrs"
                                        filled
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="modalShow.form.data"
                                    no-title
                                    @input="menuDate = false"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menuDate = false"
                                    >
                                        {{$t('cancel')}}
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuDate.save(modalShow.form.data)"
                                    >
                                        {{$t('ok')}}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelRoute">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="preFilledCreate" :disabled="!modalShow.form.isValid">
                        {{$t('confirm')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalAlert.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalAlert.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.msg}}
            </template>

            <template v-slot:modal-actions>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="confirmAlert()">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalSubRoute.show" :title="$t('environmental-management.route-management.modal-sub-route.title')" modalAlign="align__flex--center" modal-width="1200px">
            <template v-slot:modal-body>
                <v-form v-model="modalSubRoute.form.isValid">
                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                                :items="modalSubRoute.mainRouters.map(el => ({text: el.name,value: el.mainRouteId}))"
                                v-model="modalSubRoute.form.mainRouteId"
                                filled
                                :rules="formRules.defaultRules"
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.modal-sub-route.route-req')"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="modalSubRoute.form.name"
                                filled
                                :rules="formRules.defaultRules"
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.modal-sub-route.route-name-req')"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="modalSearchText"
                                class="search searchModal"
                                :label="$t('search')"
                                prepend-inner-icon="mdi-magnify"
                                @blur="addEgars"
                            ></v-text-field>

                            <v-data-table
                                v-model="modalSubRoute.listEgars.selected"
                                :headers="modalSubRoute.listEgars.headers"
                                :items="modalSubRoute.egars"
                                :footer-props="{
                                    showFirstLastPage: true,
                                    'items-per-page-options': [10, 20, 50]
                                }"
                                item-key="egarId"
                                show-select
                            >
                                <template v-slot:item.createDate="{ item }">
                                    {{item.createDate | formatOnlyDate}}
                                </template>
                                <template v-slot:item.producer="{ item }">
                                    <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                                    <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                                </template>

                                <template v-slot:item.morada="{ item }">
                                    {{item.producer.address}} {{item.producer.locality}}
                                </template>
                                <template v-slot:item.transportedResidue="{ item }">
                                    <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                                    <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                                </template>
                                <template v-slot:item.qtd="{ item }">
                                    {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelCreateRoute()">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="createRoute()" :disabled="!modalSubRoute.form.isValid">
                        {{$t('confirm')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalDeleteEgar.show" :title="$t('environmental-management.route-management.modal-delete-egar.title')" modalAlign="align__flex--center" modal-width="400px">
            <template v-slot:modal-body>
                {{$t('environmental-management.route-management.modal-delete-egar.msg')}}
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelDeleteEgar()">
                        {{$t('no')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="confirmDeleteEgar()">
                        {{$t('yes')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

    </div>
</template>

<script>
import { GetEgars } from '@services/b2b/environmental-management/EgarService'
import { GetRouterPreDefined,GetLauchPreFilled, PostLauchRouter,GetTranporterRouters, GetMainRoute,PostCreateRoute, DeleteEgarId  } from '@services/b2b/environmental-management/RouterService'

import RouteSegments from '@components/b2b/environmental-management/route-management/RouteSegments';
import OrderWithoutRoute from '@components/b2b/environmental-management/route-management/OrderWithoutRoute';
import SearchOrderWithoutRoute from '@components/b2b/environmental-management/route-management/SearchOrderWithoutRoute';
import { required } from '@src/utils/validations.js';
import dayjs from 'dayjs';
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import RouteSegmentsConveyor from "@components/b2b/environmental-management/route-management/RouteSegmentsConveyor.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

    export default {
        components:{
            BasePageHeader,
            RouteSegmentsConveyor,
            BaseModal,
            RouteSegments,
            OrderWithoutRoute,
            SearchOrderWithoutRoute
        },
        data(){
            return{
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.title')
                    }
                ],
                menuDate: false,
                routes:[],
                tableEgars: [],
                filters: [],


                modalShow: {
                    show: false,
                    form: {
                        id: null,
                        isValid: false,
                        transporters: [],
                        data: null,
                        transporter: {
                            fullName: null,
                            nif: null,
                            plateNumber: null
                        }
                    }
                },

                modalAlert:{
                    show:false,
                    msg: '',
                    noRefresh: false
                },

                filterRoutesFalse: {
                    producerNif: null,
                    actorTypeId: null,
                    recipientApaCode: null,
                    producerApaCode: null,
                    statudId: null,
                    hasRoutes: false,
                },
                formRules: {
                    defaultRules: [required]
                },

                itemsPerPage: 10,
                page: 1,
                searchCount:0,
                totalRecords: 0,

                routesTransporterNow:[],
                routesTransporterTomorrow:[],
                routesTransporterOthers:[],

                modalSubRoute: {
                    show: false,
                    form: {
                        isValid: false,
                        mainRouteId: null
                    },
                    mainRouters: [],
                    name: '',
                    listEgars:{
                        selected: [],
                        headers: [
                            {
                                text: this.$t('environmental-management.route-management.list-egars-headers.request-date'),
                                align: 'start',
                                value: 'createDate',
                            },
                            { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'producer' },
                            { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada' },
                            { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'transportedResidue' },
                            { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd' },
                            { text: '', value: 'data-table-select' },

                        ],
                    },
                    egars: []
                },
                deleteEgarId: null,
                modalDeleteEgar: {
                    show: false,
                },
                modalSearchText: ''

            }
        },
        computed: {
            isAdmin() {
                return  this.$store.getters['auth/getState'].isAdminSILiAmb;
            },
        },
        methods:{
            cancelCreateRoute(){
                this.modalSubRoute.form.mainRouteId = null;
                this.modalSubRoute.form.name = '';
                this.modalSubRoute.listEgars.selected = [];
                this.modalSubRoute.show = false;
            },
            createRoute(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                const body = {
                    mainRouterId: this.modalSubRoute.form.mainRouteId,
                    name: this.modalSubRoute.form.name,
                    egarsId: this.modalSubRoute.listEgars.selected.map(el => el.egarId)
                }

                const qtdEgarsMax = this.modalSubRoute.mainRouters.filter(el => el.mainRouteId == this.modalSubRoute.form.mainRouteId)[0].maxEgarRequest
                if(this.modalSubRoute.listEgars.selected.length > qtdEgarsMax){
                    this.modalAlert.msg = this.$t('environmental-management.route-management.modal-alert.msg1') + qtdEgarsMax;
                    this.modalAlert.show = true;
                    this.modalAlert.noRefresh = true;
                    this.$store.commit('loadings/setStateLoadingTemplate', false);

                    return
                }

                return PostCreateRoute(body)
                    .then(response => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.modal-alert.msg2')
                        this.modalAlert.show = true;
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            createSubRota(){
                this.addEgars();
            },
            addEgars(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                let filter = {
                    statusIds: [2],
                    hasRoutes: false,
                    pageSize: 4000,
                    searchText: this.modalSearchText
                }

                return GetEgars(filter)
                    .then(response => {
                        this.modalSubRoute.egars = response.data.result
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.addMainRoute()
                    })
            },
            addMainRoute(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetMainRoute()
                    .then(response => {
                        this.modalSubRoute.mainRouters = response.data.result
                        this.modalSubRoute.show = true;
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            getAllEGAR(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                Object.assign(this.filters, {
                        statusIds: [2],
                        hasRoutes: false
                    }
                )
                return GetEgars(this.filters)
                    .then(response => {
                        if(response.data.result){
                            this.totalRecords = response.data.totalRecords
                            this.tableEgars = response.data.result
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            getPreRoutes(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetRouterPreDefined()
                .then(response => {
                    this.routes = response.data.result;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get getPreRoutes values', error);
                })
                .finally(() => {
                    //this.$store.commit('loadings/setStateLoadingTemplate', false);
                    this.getAllEGAR()
                })
            },
            showModal(event){
                this.modalShow.form.id = event
                this.lauchPreFilled()
            },

            lauchPreFilled(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetLauchPreFilled()
                .then(response => {

                    this.modalShow.form.transporters = response.data.result
                    this.modalShow.show = true

                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get getPreRoutes values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            cancelRoute(){
                this.modalShow.form.id= null
                this.modalShow.form.transporter = []
                this.modalShow.form.data= null

                this.modalShow.show = false
            },

            onSearch(event, id){
                this.filters = {
                    producerNif: event.nifProdutor ? event.nifProdutor : '',
                    producerApaCode: event.apaCodeProdutor ? event.apaCodeProdutor : '',
                    createDateFrom: event.dates.length > 0?  event.dates[0]: '',
                    createDateTo: event.dates.length > 1?  event.dates[1]: '',
                    searchText: event.searchText,
                    pageSize: this.itemsPerPage,
                    currentPage: this.page,
                };

                this.searchCount = this.searchCount + 1

                this.getAllEGAR()
            },
            alterTable(event){
                this.itemsPerPage = event.itemsPerPage
                Object.assign(this.filters, {
                        pageSize: event.itemsPerPage,
                        currentPage: event.page
                    }
                )

                this.getAllEGAR()
            },
            deleteEgarById(item){
                this.deleteEgarId = item.egarId;
                this.modalDeleteEgar.show = true;
            },
            cancelDeleteEgar(){
                this.deleteEgarId = null;
                this.modalDeleteEgar.show = false;
            },
            confirmDeleteEgar(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return DeleteEgarId(this.deleteEgarId)
                .then(response => {
                    this.modalAlert.msg = this.$t('environmental-management.route-management.modal-alert.msg3')
                    this.modalAlert.show = true;

                    this.modalAlert.noRefresh = true;
                    this.getAllEGAR()
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalAlert.msg = this.$t('environmental-management.route-management.modal-alert.msg4')
                    this.modalAlert.show = true;
                    this.modalAlert.noRefresh = true;
                    throw new Error('error to get list egar values', error);
                })
                .finally(() => {
                    this.cancelDeleteEgar()
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            confirmAlert(){
                if(this.modalAlert.noRefresh){
                    this.modalAlert.noRefresh = false;

                    this.modalAlert.show = false;
                } else {
                    this.$router.go();
                }
            },
            preFilledCreate(){
                this.modalShow.show = false

                let body = {
                    transporterId: this.modalShow.form.transporter.id,
                    launchDate: dayjs(this.modalShow.form.data).format("YYYY-MM-DD") + 'T00:00:00.0000'
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return PostLauchRouter(this.modalShow.form.id, body)
                    .then(response => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.modal-alert.msg5')
                        this.modalAlert.show = true;
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modalAlert.msg = this.$t('environmental-management.route-management.modal-alert.msg6')
                        this.modalAlert.show = true;
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            getRoutesTransporter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetTranporterRouters()
                    .then(response => {
                        this.routesTransporterNow = response.data.result[0].routesNow
                        this.routesTransporterTomorrow =  response.data.result[0].routesTomorrow
                        this.routesTransporterOthers = response.data.result[0].routesOther
                    })
                    .catch(error => {
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            }
        },
        created() {
            if(this.isAdmin){
                this.getPreRoutes();
            }else{
                this.getRoutesTransporter()
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.budget-history {
    align-self: center;
    .history-btn {
        display: flex;
        max-height: 50px;
        align-items: center;
        justify-content: center;
        background-color: var(--v-info-base);
        padding: 16px 30px 16px 30px;
        border-radius: 10px;
        transition: ease $animations-time-duration;
        cursor: pointer;
        h5 {
            font-size: 18px;
        }
        &:hover {
            background-color: var(--v-info-lighten4);
            h5{
                color: var(--v-info-base) !important;
            }
            ::v-deep svg{
                path{
                    fill: var(--v-info-base) !important;
                }
            }
        }
    }

    .router_link_class {
        color: transparent !important;
    }
}


.btn-add{
    cursor: pointer;
    .circle{
        background: var(--v-primary-base);
        width: 40px;

        ::v-deep path{
            fill: #ffffff !important;
        }
    }
    &:hover{
        .circle{
            background: var(--v-primary-lighten3);
        }
    }
}

.searchModal{
    border-bottom: 1px solid #e8e8e8;
}
</style>
